import { render, staticRenderFns } from "./OrderDetailsInfo.vue?vue&type=template&id=19331612&scoped=true&"
import script from "./OrderDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsInfo.vue?vue&type=style&index=0&id=19331612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19331612",
  null
  
)

export default component.exports